import React, { Component } from 'react';
import ReactTooltip         from 'react-tooltip';
import { connect }          from 'react-redux';

class Bt_Comentario_Equipe extends Component {
    render() {

        const vetor          = this.props.vetor;
        const tur_pos_id     = this.props.all_posts_equipe[vetor].equ_pos_id;
        const qtd_comentario = this.props.all_posts_equipe[vetor].qtd_comentarios;
         
        return (

                 <a 
                    href={void(0)} 
                    className="action action-icon action-simple action-labeled"
                    data-tip data-for = {'comments_'}
                    onClick           = {this.props.funcao}
                    >
                    <i className="gamefica-icon gamefica-balloon" id={`comments_${tur_pos_id}`}></i>
                    <span>+{ qtd_comentario === 0 ? 0 : qtd_comentario }</span>
                    <ReactTooltip id={'comments_'} type='dark' effect='solid'>
                            <span>Comentário</span>
                    </ReactTooltip>
                </a>

             
          );
    }
}

function  mapStateToProps(state){

    return { 
             all_posts_equipe : state.equipeReducer.all_equipe_posts
           }
}

export default connect(mapStateToProps)(Bt_Comentario_Equipe);




// WEBPACK FOOTER //
// ./src/container/bt_comentario_equipe.js